module.exports = __webpack_public_path__ + "static/img/1.26d9f6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/7/zh/1.png
// module id = fORt
// module chunks = 0